export function redirectPathForStream(streamElement) {
  return streamElement.templateContent?.textContent?.trim() || streamElement.getAttribute?.("target")?.trim();
}

export function registerTurboStreamRedirect(Turbo) {
  Turbo.StreamActions.redirect = function() {
    const redirectPath = redirectPathForStream(this);
    if (redirectPath) Turbo.visit(redirectPath);
  };
}
